<template>
  <v-dialog persistent v-model="show" max-width="700px">
    <v-card flat>
      <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>

      <h2>{{ $t('login.password.create-new-password') }}</h2>
      <p>{{ $t('login.password.new-password-info') }}</p>
      <strong>{{ $t('login.password.new-password-requirements') }}</strong>
      <div class="mt-4">
        <v-form ref="form">
          <v-text-field
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            outlined
            :label="$t('login.password.new-password')"
            v-model="password"
            :rules="[rules.required, rules.pwdLength]"
            @click:append="showPassword = !showPassword"
          />
          <v-text-field
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            outlined
            :label="$t('login.password.confirm-new-password')"
            v-model="passwordConfirmation"
            :rules="[rules.required, rules.pwdLength, rules.pwdMatch(password, passwordConfirmation)]"
            @click:append="showPassword = !showPassword"
            :error-messages="error"
            @input="clearErrorMessages"
          />
          <ActionButton class="mt-4" type="application" @click="suggestPassword">{{
            $t('login.password.suggest-password')
          }}</ActionButton>
          <ActionButton class="mt-4" actionIcon="$sl-check-circle" @click="resetPassword">{{
            $t('login.password.create-new-password')
          }}</ActionButton>
        </v-form>
        <ActionButton class="mt-4" actionIcon="$sl-cancel" type="application" @click="$emit('close')">{{
          $t('labels.cancel')
        }}</ActionButton>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import generator from 'generate-password'
import API from '@/services/api.js'
import {RulesMixin} from '@/components/mixins'
import ActionButton from '@/components/Common/ActionButton'

export default {
  name: 'NewPasswordModal',

  mixins: [RulesMixin],

  props: {
    show: false,
    resetToken: ''
  },

  data: () => ({
    password: '',
    passwordConfirmation: '',
    showPassword: false,
    error: ''
  }),

  components: {
    ActionButton
  },

  methods: {
    resetPassword() {
      this.error = ''
      const valid = this.$refs.form.validate()
      if (!valid) return

      const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\(\)\,\;\/\=\[\]\"\:{}!@#$%^&*.?\+\-`~<>|_])(?=.{8,})/
      if (!new RegExp(strongRegex).test(this.password)) {
        this.error = this.$t('login.password.weak-password')
        return
      }

      API.resetPassword({password: this.password}, this.resetToken)
        .then(({data}) => {
          this.$emit('close', data)
        })
        .catch(() => {
          this.error = this.$t('login.password.error-on-reset')
        })
    },
    suggestPassword() {
      const newPassword = generator.generate({
        length: 8,
        numbers: true,
        symbols: true,
        lowercase: true,
        uppercase: true,
        strict: true
      })
      this.showPassword = true
      this.password = newPassword
      this.passwordConfirmation = newPassword
    },
    clearErrorMessages() {
      this.error = ''
    }
  }
}
</script>

